import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'
import { useGetCollectionsQuery } from 'hooks/useQueries'

import PaginatedSlides from 'components/display/PaginatedSlides'
import Container from '../../../../components/layout/Container'

import CollectionSlide, { PlaceholderCollectionSlide } from './CollectionSlide'

const Heading = styled.h2`
  color: ${({ theme }) => theme['-ds-core-300'].value};
  font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-lg']['font-weight'].value};
  margin-bottom: 16px;
`

type OtherCollectionsProps = {
  collectionId: string
  marketId: string
}

const OtherCollections = ({
  collectionId,
  marketId,
}: OtherCollectionsProps) => {
  const { data, loading, called, fetchMore } = useGetCollectionsQuery({
    variables: { marketId },
  })

  const { md: largerThanMd } = useMediaQueryContext()

  const pageInfo = data?.collections?.pageInfo

  const onFetchMore = () =>
    fetchMore({
      variables: {
        marketId,
        cursor: pageInfo?.endCursor,
      },
    })

  const otherCollections =
    data?.collections?.edges
      ?.map(({ node }) => node)
      ?.filter(({ id }) => id !== collectionId) || []

  return (
    <>
      <Container noPadding={largerThanMd}>
        <PaginatedSlides
          items={otherCollections || []}
          ItemComponent={CollectionSlide}
          loading={loading}
          called={called}
          canFetchMore={pageInfo?.hasNextPage}
          onFetchMore={onFetchMore}
          loadingPlaceholder={<PlaceholderCollectionSlide />}
          customTitle={<Heading>Browse Collections</Heading>}
        />
      </Container>
    </>
  )
}

export default OtherCollections
